import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'localizedDate',
  pure: false
})
export class LocalizedDatePipe implements PipeTransform {
  constructor(private translateService: TranslateService) {}

  transform(value: any, pattern: string = 'mediumDate'): any {
    const lang = this.translateService.currentLang || this.translateService.defaultLang || 'en';
    const datePipe = new DatePipe(lang);
    return datePipe.transform(value, pattern);
  }
}
